import {useEffect, useState} from 'react';

import {getEventByCodeAndSourceAndType} from 'src/openapi/apis/EventControllerApi';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';
import {EventType} from 'src/openapi/models/EventType';
import {useAppDispatch} from 'src/store';

export const useEventInfo = (
    eventCode: string,
    eventSource: string,
    eventType: EventType,
): EventBasicInfo | null => {
    const dispatch = useAppDispatch();
    const [eventBasicInfo, setEventBasicInfo] = useState<EventBasicInfo | null>(null);

    useEffect(() => {
        if (eventCode && eventSource && eventType) {
            const fetchData = async () => {
                const response =
                    await dispatch(getEventByCodeAndSourceAndType({eventCode, eventSource, eventType}));

                if (response.payload.success) {
                    setEventBasicInfo(response.payload.data);
                }
            };

            fetchData();
        }

    }, [dispatch, eventCode, eventSource, eventType]);

    return eventBasicInfo;
};
